import { Injectable } from '@angular/core';
import { SettingsService } from '../settings.service';
import { Response } from '@angular/http';
import { PontoFisico } from '../comum/modelos/ponto-fisico';
import { Setor } from '../comum/modelos/setor';
import { SetorPontoFisico } from '../comum/modelos/setor-ponto-fisico';
import { SetorCliente } from '../comum/modelos/setor-cliente';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ProcessoCliente } from '../comum/modelos/processo-cliente';

@Injectable()
export class SetorService {

    private _host: string;

    constructor(
        private _settingsService: SettingsService,
        private _http: HttpClient) {
        this._host = this._settingsService.obterHostBase() + '/setores/';
    }

    obterSetoresHttp(): Observable<Setor[]> {
        return this._http.get(this._host)
            .catch(this.handleError);
    }

    removerSetorHttp(idSetor: number): Observable<HttpResponse<Setor>> {
        return this._http.delete(this._host + idSetor, {
            observe: 'response'
        }).catch(this.handleError);
    }

    cadastrarSetorHttp(setor: Setor): Observable<HttpResponse<Setor>> {
        return this._http
            .post(this._host, setor, {
                observe: 'response'
            }).catch(this.handleError);
    }

    obterSetorPorIdHttp(id: number): Observable<Setor> {
        return this._http.get(this._host + id)
            .catch(this.handleError);
    }

    atualizarSetorHttp(setor: Setor): Observable<HttpResponse<Setor>> {
        return this._http
            .put(this._host, setor, {
                observe: 'response'
            }).catch(this.handleError);
    }

    obterSetoresClienteHttp(id: number): Observable<SetorCliente[]> {
        return this._http.get(this._host + 'cliente/' + id)
            .catch(this.handleError);
    }

    cadastrarSetoresClienteHttp(setorCliente: SetorCliente[]): Observable<HttpResponse<SetorCliente[]>> {
        return this._http
            .post(this._host + 'cliente/', setorCliente, {
                observe: 'response'
            })
            .catch(this.handleError);
    }

    removerSetoresClienteHttp(setorCliente: SetorCliente[]): Observable<HttpResponse<SetorCliente[]>> {
        return this._http
            .patch(this._host + 'cliente/', setorCliente, {
                observe: 'response'
            })
            .catch(this.handleError);
    }

    obterSetoresPontosFisicosHttp(pontosFisicos: PontoFisico[]): Observable<SetorPontoFisico[]> {
        const params = new URLSearchParams();
        let ids: string;

        for (let i = 0, len = pontosFisicos.length; i < len; i++) {
            if (i === 0) {
                ids = '?id=' + pontosFisicos[i].idPontoFisico;
            } else {
                ids = ids + '&id=' + pontosFisicos[i].idPontoFisico;
            }
        }

        params.append('ids', ids.toString());

        return this._http.get(this._host + 'ponto-fisico/' + ids)
            .catch(this.handleError);
    }

    obterSetoresPontosFisicosFromSetorClienteHttp(setoresCliente: SetorCliente[]): Observable<SetorPontoFisico[]> {
        const params = new URLSearchParams();
        let ids: string;

        for (let i = 0, len = setoresCliente.length; i < len; i++) {
            if (i === 0) {
                ids = '?id=' + setoresCliente[i].idSetorCliente;
            } else {
                ids = ids + '&id=' + setoresCliente[i].idSetorCliente;
            }
        }

        params.append('ids', ids.toString());

        return this._http.get(this._host + 'ponto-fisico/cliente/' + ids)
            .catch(this.handleError);
    }

    obterSetoresPontoFisicoHttp(idPontoFisico: number): Observable<SetorPontoFisico[]> {
        return this._http.get(this._host + 'ponto-fisico/' + idPontoFisico)
            .catch(this.handleError);
    }

    obterSetorPontoFisicoHttp(idSetorPontoFisico: number): Observable<SetorPontoFisico> {
        return this._http.get(this._host + 'setor-ponto-fisico/' + idSetorPontoFisico)
            .catch(this.handleError);
    }

    cadastrarSetoresPontoFisicoHttp(setorPontoFisico: SetorPontoFisico[]): Observable<HttpResponse<SetorPontoFisico[]>> {
        return this._http
            .post(this._host + 'ponto-fisico/', setorPontoFisico, {
                observe: 'response'
            })
            .catch(this.handleError);
    }

    removerSetoresPontoFisicoHttp(setorPontoFisico: SetorPontoFisico[]): Observable<HttpResponse<SetorPontoFisico[]>> {
        return this._http
            .patch(this._host + 'ponto-fisico/', setorPontoFisico, {
                observe: 'response'
            })
            .catch(this.handleError);
    }

    obterSetoresPontoFisicoSetoresClienteHttp(setores: SetorCliente[]): Observable<SetorPontoFisico[]> {
        const params = new URLSearchParams();
        let ids: string;

        for (let i = 0, len = setores.length; i < len; i++) {
            if (i === 0) {
                ids = '?id=' + setores[i].idSetorCliente;
            } else {
                ids = ids + '&id=' + setores[i].idSetorCliente;
            }
        }

        params.append('ids', ids.toString());
        return this._http.get(this._host + 'setor-ponto-fisico-processo/' + ids)
            .catch(this.handleError);
    }

    obterSetoresFromPontosFisicosHttp(pontosFisicos: PontoFisico[]): Observable<Setor[]> {
        const params = new URLSearchParams();
        let ids: string;

        for (let i = 0, len = pontosFisicos.length; i < len; i++) {
            if (i === 0) {
                ids = '?id=' + pontosFisicos[i].idPontoFisico;
            } else {
                ids = ids + '&id=' + pontosFisicos[i].idPontoFisico;
            }
        }

        params.append('ids', ids.toString());
        return this._http.get(this._host + 'setor-from-pontos-fisicos/' + ids)
            .catch(this.handleError);
    }

    obterSetoresClienteFromProcessoClienteHttp(processoCliente: ProcessoCliente): Observable<HttpResponse<SetorCliente[]>> {
        return this._http.post(this._host + 'processo/', processoCliente, {
            observe: 'response'
        }).catch(this.handleError);
    }

    private handleError(error: Response) {

        console.error(error);

        return Observable.throw(error.json().error || 'Server error');

    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/setor.service.ts